<p-dropdown
  [(ngModel)]="periodicity"
  (ngModelChange)="periodicityChange.emit($event)"
  [options]="options"
  [class]="class"
  [styleClass]="styleClass"
  [appendTo]="appendTo"
  [placeholder]="'\u00A0'">
  <ng-template
    let-item
    pTemplate="selectedItem">
    {{ item | periodicity }}
  </ng-template>

  <ng-template
    let-item
    pTemplate="item">
    {{ item | periodicity }}
  </ng-template>
</p-dropdown>
